export default {"src":"/_next/static/media/bg2.e04a5a3b.svg","height":333,"width":350,"blurWidth":0,"blurHeight":0};